import { useQueryClient } from '@tanstack/react-query';
import { LivePriceSymbolsKeyEnum } from 'global/Datafeed/UseLivePrice/liveprice.store.types';
import { useLivePrice } from 'global/Datafeed/UseLivePrice/useLivePrice';

export const useBuySellDatafeed = (symbol: string) => {
  const queryClient = useQueryClient();

  useLivePrice(
    [symbol],
    LivePriceSymbolsKeyEnum.TRANSACTION_FORM,
    'transaction_form',
    (data) => {
      queryClient.setQueryData(
        ['@trailing-stop/datafeed/liveprice'],
        () => data,
      );
    },
  );
};
